const SITE_URL = "https://webmenu.megriva.com";
const DEFAULT_IMAGE = `${SITE_URL}/favicon.ico`;

const upsertMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (value == null || value === "") {
      element.removeAttribute(key);
    } else {
      element.setAttribute(key, value);
    }
  });

  return element;
};

const upsertLink = (rel, href) => {
  let element = document.head.querySelector(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
  return element;
};

const removeJsonLd = (id) => {
  document.getElementById(id)?.remove();
};

const upsertJsonLd = (id, value) => {
  removeJsonLd(id);

  if (!value) return;

  const script = document.createElement("script");
  script.id = id;
  script.type = "application/ld+json";
  script.text = JSON.stringify(value);
  document.head.appendChild(script);
};

export const buildAbsoluteUrl = (pathname = "/") => {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${SITE_URL}${normalizedPath === "/" ? "/" : normalizedPath}`;
};

export const applySeo = ({
  title,
  description,
  pathname = "/",
  canonical,
  robots = "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
}) => {
  if (title) document.title = title;

  const canonicalUrl = canonical || buildAbsoluteUrl(pathname);

  upsertMeta('meta[name="description"]', {
    name: "description",
    content: description || "",
  });
  upsertMeta('meta[name="robots"]', { name: "robots", content: robots });
  upsertMeta('meta[name="googlebot"]', { name: "googlebot", content: robots });

  upsertMeta('meta[property="og:locale"]', {
    property: "og:locale",
    content: "tr_TR",
  });
  upsertMeta('meta[property="og:type"]', { property: "og:type", content: type });
  upsertMeta('meta[property="og:site_name"]', {
    property: "og:site_name",
    content: "Web Menü",
  });
  upsertMeta('meta[property="og:title"]', { property: "og:title", content: title || "" });
  upsertMeta('meta[property="og:description"]', {
    property: "og:description",
    content: description || "",
  });
  upsertMeta('meta[property="og:url"]', { property: "og:url", content: canonicalUrl });
  upsertMeta('meta[property="og:image"]', { property: "og:image", content: image });

  upsertMeta('meta[name="twitter:card"]', {
    name: "twitter:card",
    content: "summary_large_image",
  });
  upsertMeta('meta[name="twitter:title"]', {
    name: "twitter:title",
    content: title || "",
  });
  upsertMeta('meta[name="twitter:description"]', {
    name: "twitter:description",
    content: description || "",
  });
  upsertMeta('meta[name="twitter:image"]', {
    name: "twitter:image",
    content: image,
  });

  upsertLink("canonical", canonicalUrl);
  upsertJsonLd("webmenu-page-jsonld", jsonLd);
};

export const clearPageJsonLd = () => removeJsonLd("webmenu-page-jsonld");

export const SITE_ORIGIN = SITE_URL;
